
// import React, { useState, useEffect } from 'react'
// import Pagination from '../pagination/Pagination';
// import axios from 'axios'
// import { Link } from 'react-router-dom'
// import Button from 'react-bootstrap/Button';
// import Modal from 'react-bootstrap/Modal';
// import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';




// const Cabinet = () => {

//   const [showMember, setShowMember] = useState(false)


//   const [mobile, setMobile] = useState('')
//   const [photo,setPhoto] = useState('')
//   const [memberName, setMemberName] = useState('--- Select Membership Name ---')
//   const [clubName, setClubName] = useState('')
//   const [designation, setDesignation] = useState('')




//   const [show, setShow] = useState(false);
//   const handleClose = () => {
//     setShow(false)
//     setShowMember(false)
//     setMemberName('--- Select Membership Name ---')
//     setClubName('')
//   };
//   const handleShow = () => setShow(true);

//   const [cabinet, setCabinet] = useState([])
//   const [showPerPage, setShowPerPage] = useState(20)
//   const [pagination, setPagination] = useState(
//     {
//       start: 0,
//       end: showPerPage
//     }
//   )

//   const onChangePagination = (start, end) => {
//     setPagination({ start: start, end: end })
//   }

// const cabinetData = async () => {
//   const dist = sessionStorage.getItem("dist"); // ✅ Get dist
//   const res = await axios.post(`https://lionsdirectoryapi.emedha.in/cabinet/api/cabinetMaster/get`, { dist });
//   setCabinet(res.data);
// };


//   useEffect(() => {
//     cabinetData()
//     getCabinateDesignationa()
//     getClubName()
//   }, []);

//   console.log(cabinet)

//   const [query, setQuery] = useState([])

//   // https://lions320dapi.emedha.in/cabinet/post

//   const submitData = (e) => {
//     const dist = sessionStorage.getItem("dist"); // ✅ get dist
//     e.preventDefault();

    
//     if (!memberName || memberName === '--- Select Membership Name ---') {
//       return alert('Please select a valid Membership Name');
//     }
//     if (!clubName) {
//       return alert('Please enter Club Name');
//     }
//     if (!designation) {
//       return alert('Please select a Designation');
//     }
    
//     axios.post('https://lionsdirectoryapi.emedha.in/cabinet/api/cabinet/post', {
//       memberName,
//       clubName,
//       designation,
//       mobile,
//       photo,
//       dist 
//     }).then(() => {
//       alert('Data Successfully Inserted!')
//       setShow(false)
//       setShowMember(false)
//       setMemberName('--- Select Membership Name ---')
//       setClubName('')
//       setTimeout(() => cabinetData(), 100)
//     }).catch((err) => alert(err.res.data))

//   }

// const deleteData = (id) => {
//   const dist = sessionStorage.getItem("dist"); // ✅ Get dist from session/local storage

//   if (window.confirm('Are you sure to delete this data...')) {
//     axios.post(`https://lionsdirectoryapi.emedha.in/cabinet/api/cabinet/delete`, {
//       id,
//       dist // ✅ Send dist
//     })
//     .then(() => {
//       alert('Data deleted successfully!...');
//       setTimeout(() => cabinetData(), 100);
//     })
//     .catch((err) => {
//       console.error(err);
//       alert('Error deleting data');
//     });
//   }
// };


//   const search = () => {

//   }

//   const [getDesignation, setGetDesignation] = useState([])

// const getCabinateDesignationa = async () => {
//   const dist = sessionStorage.getItem("dist"); // ✅ Get dist from session/localStorage

//   const res = await axios.post('https://lionsdirectoryapi.emedha.in/cabinet/api/cabinet/get', {
//     dist
//   });

//   setGetDesignation(res.data);
// };


//   const [clubSelectName, setClubSelectName] = useState([])



//   const getClubName = async () => {
//     const dist = sessionStorage.getItem("dist"); // ✅ get dist
//     const res = await axios.get(`https://lionsdirectoryapi.emedha.in/club/api/clubName/get?dist=${dist}`);
//     setClubSelectName(res.data)
//   };
  

//   const [membershipSelectName, setMembershipSelectName] = useState([])

//   // https://lions320dapi.emedha.in/membershipname/get

// const membershipName = async (clubName) => {
  
//   setClubName(clubName);

//   const dist = sessionStorage.getItem("dist"); // ✅ Get district from session or storage

//   await axios.post('https://lionsdirectoryapi.emedha.in/member/api/membershipname/get', {
//     clubName,
//     dist
//   }).then((res) => {
//     setMembershipSelectName(res.data);
//   });
// };



//   console.log(membershipSelectName)


//   const [searchQuery, setSearchQuery] = useState('');

//   // Function to handle search input change
//   const handleSearchChange = (e) => {
//     setSearchQuery(e.target.value);
//   };
  
//   // Function to filter membership names based on search query
//   const filteredMembershipNames = membershipSelectName.filter((data) =>
//     data.membershipName.toLowerCase().includes(searchQuery.toLowerCase())
//   );
  



//   return (


//     <>
//       <Button variant="warning" onClick={handleShow}>
//         Add<PersonAddAltIcon></PersonAddAltIcon>
//       </Button>

//       <Modal show={show} onHide={handleClose} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Add</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <form onSubmit={submitData}>
//             <select type='text' className='form-control' placeholder='Designation' onChange={(e) => membershipName(e.target.value)}>
//               <option>
//                 -------Select ClubName----
//               </option>
//               {
//                 clubSelectName.map((data) => {
//                   return (

//                     <option value={data.clubName}>
//                       {data.clubName}
//                     </option>

//                   )
//                 })
//               }
//             </select>
//             <br />
//             {
//       clubName !== "" && (
//         <div>
//            <input
//                   type='text'
//                   placeholder='Search Membership Name'
//                   value={searchQuery}
//                   onChange={handleSearchChange}
//                   style={{
//                     width: '100%',
//                     padding: '0.5rem',
//                     border: '1px solid #d3d3d3',
//                     borderRadius: '0.4rem',
//                     marginBottom: '0.5rem'
//                   }}
//                 />
//           <input
//             readOnly
//             style={{
//               cursor: 'default',
//               height: '2.3rem',
//               width: '100%',
//               border: '1px solid #d3d3d3',
//               paddingLeft: '0.8rem',
//               outline: 'none',
//               borderRadius: '0.4rem'
//             }}
//             value={memberName}
//             onClick={() => setShowMember(!showMember)}
//           ></input>
//           {
//             showMember && (
//               <div style={{ height: '23rem', backgroundColor: 'white', overflowY: 'scroll', marginTop: '0.3rem' }}>
               
//                 {
//                   filteredMembershipNames.map((data) => (
//                     <p className='mem' key={data.membershipName} onClick={() => {
//                       setMobile(data.mobile);
//                       setPhoto(data.photo);
//                       setMemberName(data.membershipName);
//                       setShowMember(false);
//                     }}>
//                       {data.membershipName}
//                     </p>
//                   ))
//                 }
//               </div>
//             )
//           }
//         </div>
//       )
//     }
//             <br />
//             {
//               memberName !== "--- Select Membership Name ---" && (
//                 <select type='text' className='form-control' placeholder='Designation' onChange={(e) => setDesignation(e.target.value)}>
//                   <option>
//                     -------Select Designation----
//                   </option>
//                   {
//                     getDesignation.map((data) => {
//                       return (

//                         <option value={data.designation}>
//                           {data.designation}
//                         </option>

//                       )
//                     })
//                   }
//                 </select>
//               )
//             }
//             <br />

//             <button type='submit' className='btn btn-danger form-control'>Submit</button>
//             <br />
//             <br />
//             <button type='reset' className='btn btn-secondary form-control'>Reset</button>
//           </form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleClose}>
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>
      
//       <div style={{ marginTop: '1rem' }} className='table-container'>
//         <table className="styled-table table table-bordered">
//           <thead>
//             <tr>
//               <th>S.No</th>
//               <th>Membership Name</th>
//               <th>Club Name</th>
//               <th>Designation</th>
//               <th>Mobile</th>
//               <th>Photo</th>
//               <th>Delete</th>
//             </tr>

//           </thead>
//           <tbody className='table-bordered'>
//             {
//               cabinet.slice(pagination.start, pagination.end).map((data, index) => {
//                 return (
//                   <tr>
//                      <td>{pagination.start + index + 1}</td>

//                     <td>{data.membershipName}</td>
//                     <td>{data.clubName}</td>
//                     <td>{data.designation}</td>
//                     <td>{data.mobile}</td>
//                     <img
//                       src={`${data.photo}`}
//                       height="70px"
//                       width="70px"
//                       style={{ marginTop: "-0.4rem" }}
//                     />
//                     <td className=''>
//                       <Link to='#' className='btn btn-danger' onClick={() => deleteData(data.id)}>delete</Link>
//                     </td>
//                   </tr>
//                 )
//               })
//             }
//           </tbody>
//         </table>
//         <Pagination page={showPerPage} onChangePagination={onChangePagination} total={cabinet.length} />
//       </div>
//     </>
//   )
// }

// export default Cabinet



import React, { useState, useEffect } from 'react'
import Pagination from '../pagination/Pagination';
import axios from 'axios'
import { Link } from 'react-router-dom'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import { FaSearch } from 'react-icons/fa';

const Cabinet = () => {

  const [showMember, setShowMember] = useState(false)
  const [searchQueryy, setSearchQueryy] = useState(''); // ✅ Holds search text string
  const [filteredCabinet, setFilteredCabinet] = useState([]); // ✅ Holds live searched array subset

  const [mobile, setMobile] = useState('')
  const [photo, setPhoto] = useState('')
  const [memberName, setMemberName] = useState('--- Select Membership Name ---')
  const [clubName, setClubName] = useState('')
  const [designation, setDesignation] = useState('')

  const [displayOrder, setDisplayOrder] = useState('');
  const [displayOrderError, setDisplayOrderError] = useState('');
  const [showUpdate, setShowUpdate] = useState(false);
const [portfolio, setPortfolio] = useState('');
// State for Add Modal
const [description, setDescription] = useState('');
const [cabinetPhotoFile, setCabinetPhotoFile] = useState(null);

  const [updateData, setUpdateData] = useState({
    id: "",
    clubName: "",
    membershipName: "",
    designation: "",
    portfolio: "",
    mobile: "",
    photo: "",
  cabinetPhoto: "",    // Dedicated cabinet photo
  displayOrder: "",
  description: "",     // Cabinet description
  });

  const [updateDisplayOrderError, setUpdateDisplayOrderError] = useState("");
  const [updateCabinetPhotoFile, setUpdateCabinetPhotoFile] = useState(null);
  const handleShowUpdate = (data) => {
    setUpdateData({
      id: data.id,
      clubName: data.clubName,
      membershipName: data.membershipName,
      designation: data.designation,
      portfolio: data.portfolio || "",
      mobile: data.mobile,
      photo: data.photo,
      cabinetPhoto: data.cabinetPhoto || "",
    displayOrder: data.displayOrder || "",
    description: data.description || "",
    });

    setShowUpdate(true);
    setUpdateCabinetPhotoFile(null);
  setShowUpdate(true);
  };


// const updateCabinetData = (e) => {
//     e.preventDefault();
//     const dist = sessionStorage.getItem("dist");
//     const performedBy = sessionStorage.getItem("email");

//     // ✅ Cleaned up: Client-side duplicate check block has been removed. 
//     // The updated backend handles group-wide designation sorting orders smoothly.
//     axios
//       .post(
//         "https://lionsdirectoryapi.emedha.in/cabinet/api/cabinet/update",
//         {
//           ...updateData,
//           dist,
//           performedBy
//         }
//       )
//       .then(() => {
//         alert("Updated Successfully");
//         setShowUpdate(false);
//         cabinetData(); // Refreshes state view with new position lists
//       })
//       .catch((err) => {
//         console.log(err);
//         alert("Update Failed");
//       });
//   };  


const updateCabinetData = (e) => {
  e.preventDefault();
  const dist = sessionStorage.getItem("dist");
  const performedBy = sessionStorage.getItem("email");

  const formData = new FormData();
  formData.append("id", updateData.id);
  formData.append("clubName", updateData.clubName);
  formData.append("membershipName", updateData.membershipName);
  formData.append("designation", updateData.designation);
  formData.append("portfolio", updateData.portfolio);
  formData.append("mobile", updateData.mobile);
  formData.append("photo", updateData.photo || "");
  formData.append("displayOrder", updateData.displayOrder || "");
  formData.append("dist", dist);
  formData.append("performedBy", performedBy || "");
  formData.append("description", updateData.description || "");

  if (updateCabinetPhotoFile) {
    formData.append("cabinetPhoto", updateCabinetPhotoFile);
  } else {
    formData.append("cabinetPhoto", updateData.cabinetPhoto || "");
  }

  axios
    .post("https://lionsdirectoryapi.emedha.in/cabinet/api/cabinet/update", formData, {
      headers: { "Content-Type": "multipart/form-data" }
    })
    .then(() => {
      alert("Updated Successfully");
      setShowUpdate(false);
      cabinetData();
    })
    .catch((err) => {
      console.log(err);
      alert("Update Failed");
    });
};

// State to view full description
const [viewDescModal, setViewDescModal] = useState(false);
const [currentDesc, setCurrentDesc] = useState({ name: "", text: "" });

const handleOpenDesc = (name, text) => {
  setCurrentDesc({ name, text });
  setViewDescModal(true);
};


  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false)
    setShowMember(false)
    setMemberName('--- Select Membership Name ---')
    setClubName('')
    setPortfolio('');
    setDescription('');
  setCabinetPhotoFile(null);
  };
  const handleShow = () => setShow(true);

  const [cabinet, setCabinet] = useState([])
  const [showPerPage, setShowPerPage] = useState(20)
  const [pagination, setPagination] = useState(
    {
      start: 0,
      end: showPerPage
    }
  )

  const onChangePagination = (start, end) => {
    setPagination({ start: start, end: end })
  }

  const cabinetData = async () => {
    const dist = sessionStorage.getItem("dist"); // ✅ Get dist
    const res = await axios.post(`https://lionsdirectoryapi.emedha.in/cabinet/api/cabinetMaster/get`, { dist });
    setCabinet(res.data);
    setFilteredCabinet(res.data)
  };


  const handleCabinetSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchQueryy(value);

    const filtered = cabinet.filter((item) => 
      (item.membershipName && item.membershipName.toLowerCase().includes(value)) ||
      (item.clubName && item.clubName.toLowerCase().includes(value)) ||
      (item.designation && item.designation.toLowerCase().includes(value)) ||
      (item.mobile && item.mobile.toLowerCase().includes(value))
    );

    setFilteredCabinet(filtered);
    setPagination({ start: 0, end: showPerPage }); // ✅ Forces pagination window back to page 1 on active typing
  };

  useEffect(() => {
    cabinetData()
    getCabinateDesignationa()
    getClubName()
  }, []);

  console.log(cabinet)

  const [query, setQuery] = useState([])

  // https://lions320dapi.emedha.in/cabinet/post


  // const submitData = (e) => {
  //   e.preventDefault();

  //   const dist = sessionStorage.getItem("dist");
  //   const performedBy = sessionStorage.getItem("email");

  //   if (!memberName || memberName === "--- Select Membership Name ---") {
  //     return alert("Please select a valid Membership Name");
  //   }

  //   if (!clubName) {
  //     return alert("Please enter Club Name");
  //   }

  //   if (!designation) {
  //     return alert("Please select a Designation");
  //   }

  
  //   axios
  //     .post(
  //       "https://lionsdirectoryapi.emedha.in/cabinet/api/cabinet/post",
  //       {
  //         memberName,
  //         clubName,
  //         designation,
  //         portfolio,
  //         mobile,
  //         photo,
  //         displayOrder,
  //         dist,
  //         performedBy
  //       }
  //     )
  //     .then(() => {
  //       alert("Data Successfully Inserted!");

  //       setShow(false);
  //       setShowMember(false);
  //       setMemberName("--- Select Membership Name ---");
  //       setClubName("");
  //       setDesignation("");
  //       setPortfolio('')
  //       setDisplayOrder("");
  //       setDisplayOrderError("");

  //       setTimeout(() => cabinetData(), 100);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       alert("Error while inserting data");
  //     });
  // };


  const submitData = (e) => {
  e.preventDefault();

  const dist = sessionStorage.getItem("dist");
  const performedBy = sessionStorage.getItem("email");

  if (!memberName || memberName === "--- Select Membership Name ---") {
    return alert("Please select a valid Membership Name");
  }

  if (!clubName) {
    return alert("Please enter Club Name");
  }

  if (!designation) {
    return alert("Please select a Designation");
  }

  const formData = new FormData();
  formData.append("memberName", memberName);
  formData.append("clubName", clubName);
  formData.append("designation", designation);
  formData.append("portfolio", portfolio);
  formData.append("mobile", mobile);
  formData.append("photo", photo || ""); // Original member photo
  formData.append("displayOrder", displayOrder);
  formData.append("dist", dist);
  formData.append("performedBy", performedBy || "");
  formData.append("description", description);

  // New uploaded cabinet photo file
  if (cabinetPhotoFile) {
    formData.append("cabinetPhoto", cabinetPhotoFile);
  }

  axios
    .post("https://lionsdirectoryapi.emedha.in/cabinet/api/cabinet/post", formData, {
      headers: { "Content-Type": "multipart/form-data" }
    })
    .then(() => {
      alert("Data Successfully Inserted!");
      handleClose();
      setTimeout(() => cabinetData(), 100);
    })
    .catch((err) => {
      console.log(err);
      alert("Error while inserting data");
    });
};

  const deleteData = (id) => {
    const dist = sessionStorage.getItem("dist"); // ✅ Get dist from session/local storage
    const performedBy = sessionStorage.getItem("email");

    if (window.confirm('Are you sure to delete this data...')) {
      axios.post(`https://lionsdirectoryapi.emedha.in/cabinet/api/cabinet/delete`, {
        id,
        dist, // ✅ Send dist
        performedBy
      })
        .then(() => {
          alert('Data deleted successfully!...');
          setTimeout(() => cabinetData(), 100);
        })
        .catch((err) => {
          console.error(err);
          alert('Error deleting data');
        });
    }
  };


  const search = () => {

  }

  const [getDesignation, setGetDesignation] = useState([])

  const getCabinateDesignationa = async () => {
    const dist = sessionStorage.getItem("dist"); // ✅ Get dist from session/localStorage

    const res = await axios.post('https://lionsdirectoryapi.emedha.in/cabinet/api/cabinet/get', {
      dist
    });

    setGetDesignation(res.data);
  };


  const [clubSelectName, setClubSelectName] = useState([])



  const getClubName = async () => {
    const dist = sessionStorage.getItem("dist"); // ✅ get dist
    const res = await axios.get(`https://lionsdirectoryapi.emedha.in/club/api/clubName/get?dist=${dist}`);
    setClubSelectName(res.data)
  };


  const [membershipSelectName, setMembershipSelectName] = useState([])

  // https://lions320dapi.emedha.in/membershipname/get

  const membershipName = async (clubName) => {

    setClubName(clubName);

    const dist = sessionStorage.getItem("dist"); // ✅ Get district from session or storage

    await axios.post('https://lionsdirectoryapi.emedha.in/member/api/membershipname/get', {
      clubName,
      dist
    }).then((res) => {
      setMembershipSelectName(res.data);
    });
  };



  console.log(membershipSelectName)


  const [searchQuery, setSearchQuery] = useState('');

  // Function to handle search input change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // Function to filter membership names based on search query
  const filteredMembershipNames = membershipSelectName.filter((data) =>
    data.membershipName.toLowerCase().includes(searchQuery.toLowerCase())
  );




  return (


    <>
    <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-3" style={{ marginTop: '1.5rem' }}>
      <Button variant="warning" onClick={handleShow}>
        Add<PersonAddAltIcon></PersonAddAltIcon>
      </Button>
{/* Premium UI Filter Bar Matrix Container */}
    <div className="search-bar-wrapper position-relative" style={{ width: '100%', maxWidth: '400px' }}>
        <FaSearch 
          style={{ position: 'absolute', left: '12px', top: '12px', color: '#888', zIndex: 10 }} 
        />
        <input
          type="search"
          className="form-control ps-5"
          placeholder="Search Name, Club, Designation, Mobile..."
          value={searchQueryy}
          onChange={handleCabinetSearch} // ✅ Binds our optimized custom context filter method
          style={{ borderRadius: '0.5rem', height: '2.5rem' }}
        />
      </div>

      </div>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={submitData}>
            <select type='text' className='form-control' placeholder='Designation' onChange={(e) => membershipName(e.target.value)}>
              <option>
                -------Select ClubName----
              </option>
              {
                clubSelectName.map((data) => {
                  return (

                    <option value={data.clubName}>
                      {data.clubName}
                    </option>

                  )
                })
              }
            </select>
            <br />
            {
              clubName !== "" && (
                <div>
                  <input
                    type='text'
                    placeholder='Search Membership Name'
                    value={searchQuery}
                    onChange={handleSearchChange}
                    style={{
                      width: '100%',
                      padding: '0.5rem',
                      border: '1px solid #d3d3d3',
                      borderRadius: '0.4rem',
                      marginBottom: '0.5rem'
                    }}
                  />
                  <input
                    readOnly
                    style={{
                      cursor: 'default',
                      height: '2.3rem',
                      width: '100%',
                      border: '1px solid #d3d3d3',
                      paddingLeft: '0.8rem',
                      outline: 'none',
                      borderRadius: '0.4rem'
                    }}
                    value={memberName}
                    onClick={() => setShowMember(!showMember)}
                  ></input>
                  {
                    showMember && (
                      <div style={{ height: '23rem', backgroundColor: 'white', overflowY: 'scroll', marginTop: '0.3rem' }}>

                        {
                          filteredMembershipNames.map((data) => (
                            <p className='mem' key={data.membershipName} onClick={() => {
                              setMobile(data.mobile);
                              setPhoto(data.photo);
                              setMemberName(data.membershipName);
                              setShowMember(false);
                            }}>
                              {data.membershipName}
                            </p>
                          ))
                        }
                      </div>
                    )
                  }
                </div>
              )
            }
            <br />
            {
              memberName !== "--- Select Membership Name ---" && (
                <select type='text' className='form-control' placeholder='Designation' onChange={(e) => setDesignation(e.target.value)}>
                  <option>
                    -------Select Designation----
                  </option>
                  {
                    getDesignation.map((data) => {
                      return (

                        <option value={data.designation}>
                          {data.designation}
                        </option>

                      )
                    })
                  }
                </select>
              )
            }
            <br />
            <div className="form-group mb-3">
  <label className="fw-bold mb-1">Portfolio (Optional
    )</label>
  <input
    type="text"
    className="form-control"
    // placeholder="e.g. Health Camp, Vision, Blood Bank"
    value={portfolio}
    onChange={(e) => setPortfolio(e.target.value)}
  />
</div>
      <div className="form-group mb-3">
  <label className="fw-bold mb-1">Display Order (Group Sorting Order Rank)</label>
  <div className="d-flex gap-2">
    <input
      type="number"
      className="form-control"
      placeholder="e.g. 1 for Top in this group"
      value={displayOrder}
      onChange={(e) => setDisplayOrder(e.target.value)} // ✅ Directly mutates hook context state
    />
    {displayOrder && (
      <Button variant="outline-secondary" onClick={() => setDisplayOrder("")}>
        Clear
      </Button>
    )}
  </div>
</div>


{/* Cabinet Photo Input (Optional) */}
<div className="form-group mb-3">
  <label className="fw-bold mb-1">Cabinet Photo (Optional)</label>
  <input
    type="file"
    accept="image/*"
    className="form-control"
    onChange={(e) => setCabinetPhotoFile(e.target.files[0])}
  />
  <small className="text-muted">Upload a special cabinet photo or leave blank to keep member photo.</small>
</div>

{/* Description / Bio (Optional) */}
<div className="form-group mb-3">
  <label className="fw-bold mb-1">Cabinet Description / Bio (Optional)</label>
  <textarea
    rows="4"
    className="form-control"
    placeholder="Enter detailed bio, achievements, or duties..."
    value={description}
    onChange={(e) => setDescription(e.target.value)}
  />
</div>
            <br />

            <button type='submit' className='btn btn-danger form-control'>Submit</button>
            <br />
            <br />
            <button type='reset' className='btn btn-secondary form-control'>Reset</button>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>


      <Modal
        show={showUpdate}
        onHide={() => {
          setShowUpdate(false);
          setUpdateDisplayOrderError("");
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Cabinet</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <form onSubmit={updateCabinetData}>

            <input
              type="text"
              className="form-control"
              value={updateData.clubName}
              readOnly
            />

            <br />

            <input
              type="text"
              className="form-control"
              value={updateData.membershipName}
              readOnly
            />

            <br />

            <select
              className="form-control"
              value={updateData.designation}
              onChange={(e) =>
                setUpdateData({
                  ...updateData,
                  designation: e.target.value,
                })
              }
            >
              <option value="">Select Designation</option>

              {getDesignation.map((item) => (
                <option
                  key={item.id}
                  value={item.designation}
                >
                  {item.designation}
                </option>
              ))}
            </select>

            <br />
            <div className="form-group mb-3">
  <label className="fw-bold mb-1">Portfolio (Optional)</label>
  <input
    type="text"
    className="form-control"
    // placeholder="e.g. Health Camp, Vision, Blood Bank"
    value={updateData.portfolio || ""}
    onChange={(e) => setUpdateData({ ...updateData, portfolio: e.target.value })}
  />
</div>

       <div className="form-group mb-3">
  <label className="fw-bold mb-1">Display Order (Group Sorting Order Rank)</label>
  <div className="d-flex gap-2">
    <input
      type="number"
      className="form-control"
      placeholder="Unassigned"
      value={updateData.displayOrder || ""}
      onChange={(e) => setUpdateData({ ...updateData, displayOrder: e.target.value })}
    />
    {updateData.displayOrder && (
      <Button variant="outline-secondary" onClick={() => setUpdateData({ ...updateData, displayOrder: "" })}>
        Clear
      </Button>
    )}
  </div>
</div>

{/* Cabinet Photo Input (Optional) */}
<div className="form-group mb-3">
  <label className="fw-bold mb-1">Cabinet Photo (Optional)</label>
  {updateData.cabinetPhoto && !updateCabinetPhotoFile && (
    <div className="mb-2">
      <img
        src={updateData.cabinetPhoto}
        alt="Cabinet"
        height="65px"
        width="65px"
        style={{ borderRadius: "8px", objectFit: "cover", border: "1px solid #ccc" }}
      />
    </div>
  )}
  <input
    type="file"
    accept="image/*"
    className="form-control"
    onChange={(e) => setUpdateCabinetPhotoFile(e.target.files[0])}
  />
</div>

{/* Description / Bio (Optional) */}
<div className="form-group mb-3">
  <label className="fw-bold mb-1">Cabinet Description / Bio (Optional)</label>
  <textarea
    rows="4"
    className="form-control"
    placeholder="Enter detailed bio, achievements, or duties..."
    value={updateData.description || ""}
    onChange={(e) => setUpdateData({ ...updateData, description: e.target.value })}
  />
</div>

            <br />

            <button
              type="submit"
              className="btn btn-success form-control"
              disabled={updateDisplayOrderError}
            >
              Update
            </button>

          </form>
        </Modal.Body>
      </Modal>

      {/* Modal to view full Cabinet Description */}
<Modal 
  show={viewDescModal} 
  onHide={() => setViewDescModal(false)} 
  centered
>
  <Modal.Header closeButton>
    <Modal.Title style={{ fontSize: "18px" }}>
      Description - {currentDesc.name}
    </Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <div 
      style={{ 
        whiteSpace: "pre-wrap", 
        fontSize: "14px", 
        lineHeight: "1.6",
        maxHeight: "350px", 
        overflowY: "auto",
        backgroundColor: "#f9f9f9",
        padding: "12px",
        borderRadius: "6px"
      }}
    >
      {currentDesc.text}
    </div>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setViewDescModal(false)}>
      Close
    </Button>
  </Modal.Footer>
</Modal>

      <div style={{ marginTop: '1rem' }} className='table-container'>
        <table className="styled-table table table-bordered">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Membership Name</th>
              <th>Club Name</th>
              <th>Designation</th>
              <th>Portfolio</th>
              <th>Mobile</th>
             <th>Display Order</th> {/* ✅ Changed from 'Rating' */}
              <th>Photo</th>
              <th>Cabinet Photo</th>   {/* ✅ Added */}
        <th>Description</th>     {/* ✅ Added */}
              <th>Update</th>
              <th>Delete</th>
            </tr>

          </thead>
          <tbody className='table-bordered'>
            {
              filteredCabinet.slice(pagination.start, pagination.end).map((data, index) => {
                return (
                  <tr>
                    <td>{pagination.start + index + 1}</td>

                    <td>{data.membershipName}</td>
                    <td>{data.clubName}</td>
                    <td>{data.designation}</td>
                    <td>{data.portfolio || "—"}</td>
                    <td>{data.mobile}</td>
                    <td>{data.displayOrder}</td>
                    <img
                      src={`${data.photo}`}
                      height="70px"
                      width="70px"
                      style={{ marginTop: "-0.4rem" }}
                    />

                    {/* 2. Cabinet Photo */}
            <td className="text-center">
              {data.cabinetPhoto ? (
                <img
                  src={data.cabinetPhoto}
                  alt="Cabinet"
                  height="55px"
                  width="55px"
                  style={{ borderRadius: "8px", objectFit: "cover", border: "1px solid #ddd" }}
                />
              ) : (
                <span className="text-muted small">—</span>
              )}
            </td>

            {/* 3. Description preview with popup modal */}
            <td style={{ minWidth: "160px" }}>
              {data.description ? (
                <div>
                  <span style={{ fontSize: "13px" }}>
                    {data.description.length > 35 
                      ? `${data.description.substring(0, 35)}...` 
                      : data.description}
                  </span>
                  {data.description.length > 35 && (
                    <button
                      type="button"
                      className="btn btn-link p-0 ms-1"
                      style={{ fontSize: "12px", textDecoration: "none" }}
                      onClick={() => handleOpenDesc(data.membershipName, data.description)}
                    >
                      Read more
                    </button>
                  )}
                </div>
              ) : (
                <span className="text-muted small">—</span>
              )}
            </td>
                    <td>
                      
                      <button
                        className="btn btn-info"
                        onClick={() => handleShowUpdate(data)}
                      >
                        Update
                      </button>
                    </td>
                    <td className=''>
                      <Link to='#' className='btn btn-danger' onClick={() => deleteData(data.id)}>delete</Link>
                    </td>
                  </tr>
                )
              })
            }
          </tbody>
        </table>
        <Pagination page={showPerPage} onChangePagination={onChangePagination} total={filteredCabinet.length} />
      </div>
    </>
  )
}

export default Cabinet